export class QualificationListDTO {

    id: string;

    name: string;

    description: string;

}
